import { MapPin, Shield, Clock, Euro } from "lucide-react";
import MobilePaymentCard from "./sections/mobile-payment-card";
import BikeParkinStatsSection from "./sections/bikeparking-stats-section";
import CityBenefitsSection from "./sections/city-benefits-section";
import AppWebAppSection from "./sections/app-webapp-section";
import DashboardSection from "./sections/dashboard-section";
import AiSupportSection from "./sections/ai-support-section";
import HardwarePartnersSection from "./sections/hardware-partners-section";
import CTASection from "../../components/cta-section";
import { useTranslation } from "../../i18n";

export default function BikeParkingRoute() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen overflow-x-hidden">
      {/* Gradient Background */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-red-500 via-purple-600 to-blue-500 opacity-90" />

      {/* Diagonal White Section */}
      <div className="absolute top-0 left-0 right-0 h-[800px] -z-5">
        <div className="absolute top-0 left-0 right-0 h-full bg-white transform -skew-y-6 origin-top-left translate-y-[30%]" />
      </div>

      {/* Main Content */}
      <main className="relative z-10 px-4 md:px-8 pt-32 pb-24">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 text-blue-800 mb-6">
              <MapPin className="w-4 h-4 mr-2" />
              <span className="text-sm font-medium">
                {t('bikeParking.hero.forCities')}
              </span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-navy-900 leading-tight">
              {t('routes.bikeParking.heroTitle')}
            </h1>
            <p className="mt-6 text-gray-700 text-lg">
              {t('bikeParking.hero.description')}
            </p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-green-100 flex items-center justify-center">
                  <Clock className="h-5 w-5 text-green-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('bikeParking.hero.fastImplementation')}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-blue-100 flex items-center justify-center">
                  <Shield className="h-5 w-5 text-blue-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('bikeParking.hero.gdprCompliant')}
                </span>
              </div>
              <div className="flex items-center">
                <div className="h-10 w-10 flex-shrink-0 mr-3 rounded-full bg-purple-100 flex items-center justify-center">
                  <Euro className="h-5 w-5 text-purple-600" />
                </div>
                <span className="text-sm font-medium">
                  {t('bikeParking.hero.costEfficient')}
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-center">
            <div className="relative">
              <MobilePaymentCard />
              <div className="absolute -right-32 -bottom-16 w-80 h-64">
                <BikeParkinStatsSection />
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* City Benefits Section */}
      <CityBenefitsSection />

      {/* App & WebApp Section */}
      <AppWebAppSection />

      {/* Dashboard Section */}
      <DashboardSection />

      {/* AI Support Section */}
      <AiSupportSection />

      {/* Hardware Partners Section */}
      <HardwarePartnersSection />

      {/* Osnabrück Reference Section */}
      {/* <OsnabrueckReferenceSection /> */}

      {/* CTA Section */}
      <CTASection />
    </div>
  );
}
